import React from "react";

function GetSwithDeFiW() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Get Started with DeFi Wallet Development Today</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  Empower your users with a secure, feature-rich solution for
                  managing and interacting with decentralized finance platforms.
                  Whether you’re a startup, fintech company, or established
                  business, Xeer Technology offers tailor-made DeFi wallet
                  solutions that provide seamless access to DeFi protocols,
                  multi-chain support, and cutting-edge security features.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default GetSwithDeFiW;
